import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

class Loading extends Component {
  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <CircularProgress color="inherit" />
      </div>
    );
  }
}
export default Loading;
